<div *ngIf="detailsInput != null">
  <div>
    <label class="data"> Tag : </label>{{ detailsInput.tag}}
    <label class="data">EPL Short : </label>{{ detailsInput.epl }}
    <label class="data">EPL Long : </label>{{ detailsInput.epL_Long }}
  </div>
</div>

<div class="details-grid popup-table-block" id="nonStyleMwoGrid">
  <kendo-grid class="popup-table-container" [data]="dataList" >
    <kendo-grid-column *ngFor="let column of columnConfig" [field]="column.field" [title]="column.title"
      [width]="column.width">
    </kendo-grid-column>
  </kendo-grid>
</div>